export default __webpack_public_path__ + "static/media/meta-logo.5b1ecf1d.png";